// section five
import { FC } from 'react'

const SectionFive: FC = () => {
  return (
    <section className="w-full bg-white px-6 py-15 laptop:py-30 laptop:px-0">
      <div className="w-full max-w-300 flex flex-col laptop:flex-row laptop:justify-between mx-auto gap-6 laptop:gap-35">
        <h2 className="text-24 laptop:text-5xl font-semibold text-[#fc7216] shrink-0">About PUDU</h2>
        <p className="text-14 laptop:text-xl text-black/90 w-full laptop:w-744px font-normal ">
          Pudu Robotics has been rapidly growing in recent years to become a “leader” in the global markets with
          coverage of over 60 countries, 60000+ units of robots are shipped worldwide which are widely applied in
          restaurants, hospitals, schools, office buildings, government halls, subway stations, waiting rooms, etc. Pudu
          Robotics already won recognition from many world-renowned companies.
        </p>
      </div>
    </section>
  )
}

export default SectionFive
